import React from 'react';
import { useTranslation } from 'react-i18next';
import { DropDown } from '@/components/design-system/molecules/dropdown';
import { useGetOutgoingTransactionsListFilterContext } from '../../../../hooks/use-get-outgoing-transactions-list-filter';

const categoryList = [
  { slug: 'cleaning_refund', displayValue: 'Refund (Cleaning)' },
  { slug: 'rent_refund', displayValue: 'Refund (Rent)' },
  { slug: 'deposit_refund', displayValue: 'Refund (Deposit)' },
  { slug: 'utility', displayValue: 'Service Provider (Utility)' },
  { slug: 'repair', displayValue: 'Service Provider (Repair)' },
  { slug: 'compensation', displayValue: 'Compensation' },
  { slug: 'payout', displayValue: 'Payout' },
];

const TransactionCategoryDropDown = () => {
  const { selectedCategory, setSelectedCategory } = useGetOutgoingTransactionsListFilterContext()!;
  const { t } = useTranslation();

  return (
    <DropDown
      placeholder={
        t(
          'js.features.admin.transactions.outgoing_transactions_list.filters.category_placeholder'
        ) ?? 'All'
      }
      className="z-50 w-[180px]"
      showLabel
      label={
        t('js.features.admin.transactions.outgoing_transactions_list.filters.category_label') ??
        'Category'
      }
      value={selectedCategory}
      onChange={setSelectedCategory}
      {...(selectedCategory && {
        displayValue: selectedCategory.displayValue,
      })}
    >
      <DropDown.DropDownOptions>
        {categoryList.map((option) => {
          return (
            <DropDown.DropDownOption key={option.displayValue} value={option}>
              <DropDown.DropDownOptionDefaultContent>
                {option.displayValue}
              </DropDown.DropDownOptionDefaultContent>
            </DropDown.DropDownOption>
          );
        })}
      </DropDown.DropDownOptions>
    </DropDown>
  );
};

export { TransactionCategoryDropDown };
